import { FormFieldSelectNG } from '../../Form'
import {
  FormikField,
  getFormikFormFieldErrorProps,
  useFormikSelectFieldGetEmptyValue,
} from '../../Formik'
import { PostMessageTemplateSelect } from '../PostMessageTemplateSelect'

function PostMessageTemplateSelectFormikField({
  Select = PostMessageTemplateSelect,
  ...restProps
}) {
  const emptyValue = useFormikSelectFieldGetEmptyValue(restProps)

  return (
    <FormikField
      {...restProps}
      Component={FormFieldSelectNG}
      Select={Select}
      emptyValue={emptyValue}
      getErrorProps={getFormikFormFieldErrorProps}
    />
  )
}

export default PostMessageTemplateSelectFormikField
